import type { NotSerializedBookingMode } from "../../../features/Booking-Form/typings/booking-inputs";
import type { BookingFavoriteDto } from "../../../hooks/Remote/BookingFavorites/booking-favorites.types";

/**
 * Inventory ids marked as favorites for the current booking mode, or undefined when
 * favorites are missing or mode is not set.
 */
export function getFavoriteInventoryIdsSetForMode(
  favorites: BookingFavoriteDto[] | undefined,
  mode: NotSerializedBookingMode
): Set<number> | undefined {
  if (!favorites || !mode) {
    return undefined;
  }
  return new Set(favorites.filter(f => f.bookingType === mode).map(f => f.bookingInventoryId));
}

/**
 * The API's recommended favorite when it matches the current booking mode; otherwise null.
 */
export function getRecommendedFavoriteForMode(
  recommended: BookingFavoriteDto | null | undefined,
  mode: NotSerializedBookingMode
): BookingFavoriteDto | null {
  if (!recommended || !mode || recommended.bookingType !== mode) {
    return null;
  }
  return recommended;
}
